/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum HealthStatus {
  Ok = "ok",
  Malfunction = "malfunction",
  Notraffic = "notraffic",
  Unknown = "unknown",
}
